import { computed } from 'vue';

import { DASHBOARD_ROUTE_NAMES } from '@/app/dashboards/constants';
import { useDashboardsStore } from '@/stores/dashboards';
import { useDashboardReportsStore } from '@/stores/dashboards-reports';
import { useIdentityStore } from '@/stores/identity';

export function useDashboardsVisionAi() {
  const identityStore = useIdentityStore();
  const dashboardsStore = useDashboardsStore();
  const dashboardReportsStore = useDashboardReportsStore();

  const dashboardIntentQuery = computed(() => {
    const dashboardId = dashboardsStore.currentDashboardId;
    const userId = identityStore.identity?.id;
    const [startDate, endDate] = dashboardReportsStore.reportDateRangeInUserTimezone;
    const [contextStartDate, contextEndDate] = dashboardReportsStore.contextDateRangeInUserTimezone;
    const currentBrandId = identityStore.currentBrand.id;

    return {
      currentBrandId,
      dashboardId,
      userId,
      startDate,
      endDate,
      contextStartDate,
      contextEndDate,
    };
  });

  const hasNoDashboards = computed(() => !dashboardsStore.hasDashboards);

  function formatDateRangeFromIntentQuery(intentQuery) {
    return {
      startDate: dashboardReportsStore.convertUtcDateTimeToLocalTimeByTimeZone(
        intentQuery?.startDate,
      ),
      endDate: dashboardReportsStore.convertUtcDateTimeToLocalTimeByTimeZone(intentQuery?.endDate),
      contextStartDate: dashboardReportsStore.convertUtcDateTimeToLocalTimeByTimeZone(
        intentQuery?.contextStartDate,
      ),
      contextEndDate: dashboardReportsStore.convertUtcDateTimeToLocalTimeByTimeZone(
        intentQuery?.contextEndDate,
      ),
    };
  }

  function getDashboardUrlFromIntentQuery(intentQuery) {
    return {
      name: DASHBOARD_ROUTE_NAMES.ID,
      params: { id: intentQuery.dashboardId },
      query: formatDateRangeFromIntentQuery(intentQuery),
    };
  }

  return {
    dashboardIntentQuery,
    formatDateRangeFromIntentQuery,
    getDashboardUrlFromIntentQuery,
    hasNoDashboards,
  };
}
